import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/ApproveAccountDialog.css";

const CorrectionNeededAccountDialog = ({
  open,
  onClose,
  onSave,
  isLoading,
}) => {
  const [correctionComment, setCorrectionComment] = useState("");

  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "account-approval-dialog-container",
        sx: { borderRadius: "20px" },
      }}
    >
      <DialogContent>
        <CloseOutlined
          className="account-approval-dialog-close"
          onClick={onClose}
        />
        <div className="account-approval-dialog-content">
          <div className="account-approval-dialog-title-container">
            <div className="account-approval-dialog-title">
              Correction Needed
            </div>
            <div className="account-approval-dialog-subtitle">
              Describe here what must be corrected.
            </div>
          </div>
          <TextField
            id="correction-needed-account-detail-text-field"
            fullWidth
            multiline
            rows={5}
            placeholder="Describe here"
            variant="outlined"
            value={correctionComment}
            onChange={(e) => setCorrectionComment(e.target.value)}
            InputProps={{
              autoComplete: "off",
              style: {
                borderRadius: "10px",
                height: "158px",
                marginBottom: "10px",
                fontSize: "18px",
                fontFamily: "Inter, sans-serif",
                fontWeight: "500",
              },
            }}
            className="account-approval-dialog-textfield"
          />
          <Button
            variant="contained"
            color="send"
            onClick={!isLoading ? () => onSave(correctionComment) : null}
            disabled={!correctionComment.trim()}
            endIcon={
              isLoading ? <CircularProgress size={30} color="inherit" /> : null
            }
          >
            Send
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CorrectionNeededAccountDialog;
